import {createAsyncThunk} from '@reduxjs/toolkit';
import {CLDispatch, RootState} from 'common/src/redux/store';
import {setAssetTree, setCurrentFolderId, setIsLoadingTree} from '../brandAssets.slice';
import {AssetFolderEntityType} from 'common/src/modules/Assets/Assets.enums';
import {loadAssetTreeUtil} from 'common/src/modules/Assets/store/shared/assetDisplayThunkUtils';

/**
 * Load initial tree structure for Brand entity type
 * Uses depth=0 to fetch root folder assets and folders, not more
 */
export const loadBrandAssetTree = createAsyncThunk<
  void,
  void,
  {dispatch: CLDispatch; state: RootState}
>('brandAssets/loadBrandAssetTree', async (_, {dispatch, rejectWithValue}) => {
  try {
    dispatch(setIsLoadingTree(true));

    const tree = await loadAssetTreeUtil(AssetFolderEntityType.Brand, undefined, 99);// brand assets we want preloading all tree depth

    dispatch(setAssetTree(tree));
    // folderPathIds is derived from currentFolderId in CLAssetDisplay
    dispatch(setCurrentFolderId(tree.folderId));
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to load asset tree';

    return rejectWithValue(errorMessage);
  } finally {
    dispatch(setIsLoadingTree(false));
  }
});

